import { createContext, useContext, useEffect, useState } from "react";

const CompareContext = createContext(null);
const KEY = "kv_compare_ids";
const MAX = 4;

export function CompareProvider({ children }) {
  const [ids, setIds] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) setIds(JSON.parse(raw));
    } catch { /* ignore */ }
  }, []);

  useEffect(() => {
    try { localStorage.setItem(KEY, JSON.stringify(ids)); } catch { /* ignore */ }
  }, [ids]);

  const toggle = (id) => {
    setIds((cur) => {
      if (cur.includes(id)) return cur.filter((x) => x !== id);
      if (cur.length >= MAX) return cur;
      return [...cur, id];
    });
  };
  const remove = (id) => setIds((cur) => cur.filter((x) => x !== id));
  const clear = () => setIds([]);
  const setAll = (arr) => setIds((arr || []).slice(0, MAX));
  const has = (id) => ids.includes(id);
  const isFull = () => ids.length >= MAX;

  return (
    <CompareContext.Provider value={{ ids, toggle, remove, clear, setAll, has, isFull, max: MAX }}>
      {children}
    </CompareContext.Provider>
  );
}

export const useCompare = () => {
  const ctx = useContext(CompareContext);
  if (!ctx) throw new Error("useCompare must be inside CompareProvider");
  return ctx;
};
